import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Button,
  Fab,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Divider,
  CircularProgress,
  styled,
  SelectChangeEvent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Paper,
  Alert,
  AlertTitle,
  Collapse,
  TextField,
  FormControlLabel,
  RadioGroup,
  Radio,
  Switch,
  List,
  ToggleButtonGroup,
  ToggleButton,
  Slider,
  Menu,
  ButtonGroup,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
  Autocomplete,
  Tabs,
  Tab,
  TablePagination,
  Tooltip
} from '@mui/material';
import {
  Add as AddIcon,
  TaskAlt as TaskIcon,
  Person as PersonIcon,
  CheckCircle as CompletedIcon,
  PendingActions as PendingIcon,
  PlayCircleFilled as StartedIcon,
  Assignment as AssignmentIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
  ViewModule as ViewModuleIcon,
  ViewList as ViewListIcon,
  QrCode as QrCodeIcon,
  Print as PrintIcon,
  Image as ImageIcon,
  TextFields as TextFieldsIcon,
  Save as SaveIcon,
  FolderOpen as FolderOpenIcon,
  Download as DownloadIcon,
  FormatAlignLeftOutlined,
  FormatAlignCenterOutlined,
  FormatAlignRightOutlined,
  FormatBoldOutlined,
  FormatItalicOutlined,
  Category as CategoryIcon,
  FileDownload as FileDownloadIcon,
  Search as SearchIcon,
  Today as TodayIcon,
  DateRange as WeekIcon,
  CalendarViewDay as TakvimIcon,
  CalendarMonth as MonthIcon,
  CalendarToday as YearIcon,
  Business as BusinessIcon,
  FilterList as FilterListIcon,
  LocationOn as LocationOnIcon,
  PhoneAndroid as PhoneAndroidIcon,
  ListAlt as ListAltIcon,
  Groups as GroupsIcon,
  Cancel as CancelIcon, // Red butonu için ikon eklendi
  LocationCity as LocationCityIcon // Yeni ikonu eklendi
} from '@mui/icons-material';
import { getPersonnel as getPersonnelSql } from '../../services/migration/personnelDataService';
import firebaseDataService from '../../services/FirebaseDataService';
import { getBranches as getBranchesAdapter } from '../../services/migration/branchDataService';
import TimeService from '../../services/TimeService';
import TaskTimeService, { TaskTimeStatus } from '../../services/TaskTimeService';
import { taskDataService, parseStringArray, stringifyStringArray, normalizeBranchesId } from '../../services/taskDataService';
import type { TaskDto, CompanyCompletionDto, LegacyTaskGroup } from '../../services/taskDataService';
import { useAuth } from '../../contexts/AuthContext';
import { QRCodeCanvas } from 'qrcode.react';
import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image';
import AddTaskModal from './modals/AddTaskModal';
import QrPrintModal from './modals/QrPrintModal';
import TaskDetailModal from './modals/TaskDetailModal';
import TaskGroupsModal from './modals/TaskGroupsModal';
import GuideButton from '../common/guide/GuideButton';
// Import uuid tipini ve v4 fonksiyonunu ayrı ayrı tanımlama
import * as uuidModule from 'uuid';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import WeeklyTasks from './components/WeeklyTasks';
import { MonthlyTasks } from './components';
import { YearlyTasks } from './components';
import { Takvim } from './components';
import { ExcelExportButton } from './utils/exportUtils';
import DeviceInfoModal from './components/DeviceInfoModal';
// Yeni oluşturduğumuz TasksTable bileşenini import ediyoruz
import TasksTable from './components/TasksTable';
// Yeni oluşturduğumuz TaskGrid bileşenini import ediyoruz
import TaskGrid from './components/TaskGrid';
// Yeni oluşturduğumuz TasksFilter bileşenini import ediyoruz
import TasksFilter from './components/TasksFilter';
import TasksNormalView from './components/TasksNormalView';
import TasksDailyView from './components/TasksDailyView';
import TeamTasks from './components/TeamTasks';
import CreateTeamModal from './modals/CreateTeamModal';
import CreateTeamTaskModal from './modals/CreateTeamTaskModal';
import TaskLocationModal from './modals/TaskLocationModal'; // Yeni modalı import et
import { useTranslation } from 'react-i18next';
const uuidv4 = uuidModule.v4;

// Kaydırılabilir ana içerik için styled component
const ScrollableContent = styled(Box)(({ theme }) => ({
  padding: 0, // Tüm padding'i kaldırıyoruz
  overflowY: 'auto',
  height: 'calc(100vh - 64px)', // Header yüksekliğini çıkarıyoruz
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
}));

// Görev kartı için styled component
// const TaskCard = styled(Card)(({ theme }) => ({
//   height: '100%',
//   borderRadius: 12,
//   boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
//   display: 'flex',
//   flexDirection: 'column',
// }));

// Görev zamanı chip bileşeni
// const TaskTimeChip = styled(Chip)<{ status: string }>(({ theme, status }) => ({
//   backgroundColor: `${status}20`, // Renkli arkaplan
//   color: status,
//   fontSize: '0.7rem',
//   height: 20
// }));

// Filtre alanı için styled component
const FilterContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: 12,
  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
}));

// Başlık alanı için styled component
const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  margin: 0,
  padding: theme.spacing(0, 3),
  backgroundColor: theme.palette.background.paper,
  borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
  boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  position: 'sticky',
  top: 0,
  zIndex: 10,
  height: '60px', // Sabit yükseklik 
}));

// Tüm sayfa içerik alanı için container
const ContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 3, 3, 3), // Sadece yanlarda ve altta padding
}));

// Yükleme ekranı için container
const LoadingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(6),
}));

// Veri yok görünümü için container
const NoDataBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(6),
  backgroundColor: theme.palette.background.paper,
  borderRadius: 12,
  marginTop: theme.spacing(3),
}));

// İnce görev kartı için styled component
const SlimTaskCard = styled(Card)(({ theme }) => ({
  borderRadius: 8,
  boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
  margin: '4px 0',
  transition: 'background-color 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: theme.palette.grey[50],
    cursor: 'pointer'
  }
}));

// Durum filtresi için seçenekler
// const statusOptions = [
//   { value: 'all', label: 'Tüm Görevler' },
//   { value: 'completed', label: 'Tamamlanan', color: '#4CAF50' },
//   { value: 'accepted', label: 'Kabul Edilmiş', color: '#9C27B0' },
//   { value: 'pending', label: 'Beklemede', color: '#FF9800' },
//   { value: 'missed', label: 'Tamamlanmamış', color: '#F44336' },
// ];

interface TasksProps {
  branchId?: string;
  isManager?: boolean;
}

interface TaskData {
  name: string;
  description: string;
  personnelId: string;
  status: string;
  isRecurring: boolean;
  completionType: string;
  createdAt: number;
  repeatType?: string;
  startTolerance?: number;
  dailyRepetitions?: number;
  repetitionTimes?: string[];
  weekDays?: number[];
  monthDay?: number;
  yearDate?: string;
  groupId?: string;
  branchesId?: string;
  deadline?: string; // Bitiş tarihi için yeni alan eklendi
  startDate?: string; // Başlangıç tarihi için yeni alan eklendi
}

const Tasks: React.FC<TasksProps> = ({ branchId, isManager = false }) => {
  // Translation hook
  const { t } = useTranslation('common2');
  // Faz 5 DILIM 3: companyId RTDB users/{uid} yerine AuthContext'ten.
  const { userDetails, currentUser } = useAuth();
  
  // State tanımlamaları
  const [loading, setLoading] = useState(true);
  const [tasks, setTasks] = useState<any[]>([]);
  const [completedTasks, setCompletedTasks] = useState<any[]>([]);
  const [missedTasks, setMissedTasks] = useState<any[]>([]);
  const [personnel, setPersonnel] = useState<any[]>([]);
  const [taskGroups, setTaskGroups] = useState<any[]>([]);
  // Faz 5 DILIM 3: görev mutasyonları sonrası veri yenileme tetikleyicisi
  const [refreshNonce, setRefreshNonce] = useState(0);
  const triggerRefresh = useCallback(() => setRefreshNonce((n) => n + 1), []);
  const [statusFilter, setStatusFilter] = useState<string>('all');
  const [personnelFilter, setPersonnelFilter] = useState<string>('all');
  const [groupFilter, setGroupFilter] = useState<string>('all'); // Yeni grup filtresi state'i
  const [personnelSearchTerm, setPersonnelSearchTerm] = useState<string>('');
  const [taskSearchTerm, setTaskSearchTerm] = useState<string>('');
  const [companyId, setCompanyId] = useState<string | null>(null);
  const [selectedTask, setSelectedTask] = useState<any | null>(null);
  const [taskDetailOpen, setTaskDetailOpen] = useState(false);
  const [addTaskModalOpen, setAddTaskModalOpen] = useState(false);
  const [taskGroupsModalOpen, setTaskGroupsModalOpen] = useState(false);

  // Faz 5 DILIM 1: grup ekleme/silme sonrasi SQL'den tekrar yukle (RTDB-uyumlu sekil).
  const reloadTaskGroups = useCallback(async () => {
    try {
      const groups = await taskDataService.listGroupsLegacy();
      setTaskGroups(Array.isArray(groups) ? groups : []);
    } catch (error) {
      console.error('Görev grupları yeniden yüklenirken hata:', error);
    }
  }, []);
  const [viewMode, setViewMode] = useState<'card' | 'list'>('card');
  // Görev zamanı durumları
  const [taskTimeStatuses, setTaskTimeStatuses] = useState<Record<string, any>>({});
  const [isCheckingTasks, setIsCheckingTasks] = useState(false);
  const [qrPrintModalOpen, setQrPrintModalOpen] = useState(false);
  const [selectedTaskForQr, setSelectedTaskForQr] = useState<any | null>(null);
  // Bilgi modalı state'i
  // Görev tipi sekmesi state'i
  const [taskType, setTaskType] = useState<'normal' | 'team' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'takvim'>('normal');
  // Şube bilgisi state'i
  const [branches, setBranches] = useState<{[key: string]: string}>({});
  const [showFilters, setShowFilters] = useState(false); // Filtre görünürlüğü için yeni state
  const [branchFilter, setBranchFilter] = useState<string>('all'); // Şube filtresi için state değişkeni
  // Cihaz bilgileri için state
  const [deviceModalOpen, setDeviceModalOpen] = useState(false);
  const [selectedDeviceInfo, setSelectedDeviceInfo] = useState<any>(null);
  // Kullanıcı tam adı state'i
  const [userFullName, setUserFullName] = useState<string>('');
  // Ekip oluşturma modalı için state
  const [createTeamModalOpen, setCreateTeamModalOpen] = useState(false);
  // Ekip görevi ekleme modalı için state
  const [createTeamTaskModalOpen, setCreateTeamTaskModalOpen] = useState(false);
  // Görünüm seçimi için state ekle (görevler/ekipler)
  const [teamDisplayMode, setTeamDisplayMode] = useState<'tasks' | 'teams'>('tasks');
  // Red nedenini göstermek için modal açma işlevi
  const [rejectReasonModalOpen, setRejectReasonModalOpen] = useState(false);
  const [selectedRejectReason, setSelectedRejectReason] = useState<string>('');
  // Konum modalı için state'ler
  const [taskLocationModalOpen, setTaskLocationModalOpen] = useState(false);
  const [selectedTaskForLocation, setSelectedTaskForLocation] = useState<any | null>(null);

  // isManager olduğunda takvim tabı seçilmişse, otomatik olarak daily'ye geçiş yap
  useEffect(() => {
    if (isManager && taskType === 'takvim') {
      setTaskType('daily');
    }
  }, [isManager, taskType]);

  // Kullanıcının tam adını yükle
  useEffect(() => {
    const fetchUserFullName = async () => {
      const user = currentUser;
      if (!user) return;
      
      try {
        console.log("Tasks - Kullanıcı tam adı yükleniyor...");
        const userData = await firebaseDataService.getUserData(user.uid);
        
        if (userData) {
          const fullName = `${userData.firstName || ''} ${userData.lastName || ''}`.trim();
          if (fullName) {
            setUserFullName(fullName);
            console.log("Tasks - Kullanıcı tam adı yüklendi:", fullName);
          } else {
            setUserFullName(user.displayName || (user.email ? user.email.split('@')[0] : 'Kullanıcı'));
            console.log("Tasks - Firebase'de tam ad bulunamadı, alternatif kullanıldı");
          }
        } else {
          setUserFullName(user.displayName || (user.email ? user.email.split('@')[0] : 'Kullanıcı'));
          console.log("Tasks - Kullanıcı verisi bulunamadı, alternatif kullanıldı");
        }
      } catch (error) {
        console.error("Tasks - Kullanıcı tam adı alınırken hata:", error);
        setUserFullName(user.displayName || (user.email ? user.email.split('@')[0] : 'Kullanıcı'));
      }
    };
    
    fetchUserFullName();
  }, []);

  // Cihaz bilgisi modalını açma işlevi
  const handleOpenDeviceModal = (deviceInfo: any) => {
    setSelectedDeviceInfo(deviceInfo);
    setDeviceModalOpen(true);
  };

  // Cihaz bilgisi modalını kapatma işlevi
  const handleCloseDeviceModal = () => {
    setDeviceModalOpen(false);
  };

  // Konum modalını açma işlevi
  const handleOpenTaskLocationModal = (task: any) => {
    setSelectedTaskForLocation(task);
    setTaskLocationModalOpen(true);
  };

  // Konum modalını kapatma işlevi
  const handleCloseTaskLocationModal = () => {
    setTaskLocationModalOpen(false);
    setSelectedTaskForLocation(null);
  };

  // Verileri saklamak için referanslar oluşturuyorum
  const [weeklyTasksData, setWeeklyTasksData] = useState<any[]>([]);
  const [monthlyTasksData, setMonthlyTasksData] = useState<any[]>([]);
  const [yearlyTasksData, setYearlyTasksData] = useState<any[]>([]);

  // Görünüm modunu localStorage'dan yükle
  useEffect(() => {
    const savedViewMode = localStorage.getItem('tasksViewMode');
    if (savedViewMode === 'list' || savedViewMode === 'card') {
      setViewMode(savedViewMode);
    }
  }, []);
  
  // Şubeleri yükle
  useEffect(() => {
    const loadBranches = async () => {
      if (!companyId) {
        console.warn("Tasks: Şube yüklenemiyor çünkü companyId değeri bulunamadı:", companyId);
        return;
      }
      
      try {
        console.log("Tasks: Şubeler yükleniyor (SQL-once)...");
        const serviceBranches = await getBranchesAdapter(companyId);
        const branchesMap: {[key: string]: string} = {};
        serviceBranches.forEach((b) => {
          branchesMap[b.id] = b.name || 'İsimsiz Şube';
        });
        setBranches(branchesMap);
      } catch (error) {
        console.error('Şube verileri yüklenirken hata:', error);
      }
    };
    
    loadBranches();
  }, [companyId]);
  
  // Şube adını getir
  const getBranchName = (branchId: string | null) => {
    if (!branchId) return '-';
    
    // branchId bir nesne mi kontrol et ve düzenle
    if (typeof branchId === 'object' && branchId !== null) {
      const keys = Object.keys(branchId);
      if (keys.length > 0) {
        const firstKey = keys[0];
        branchId = firstKey;
      }
    }
    
    // Artık branchId bir string olmalı, şube adını döndür
    return branches[branchId as string] || `Şube ${branchId}`;
  };

  // Duruma göre renk döndüren yardımcı fonksiyonu güncelle
  const getStatusColor = (status: string): string => {
    switch (status) {
      case 'completed':
        return '#4CAF50'; // Yeşil
      case 'accepted':
      case 'assigned':
        return '#1976D2'; // Mavi
      case 'waiting':
        return '#2196F3'; // Açık Mavi
      case 'pending':
        return '#FF9800'; // Turuncu
      case 'missed':
        return '#F44336'; // Kırmızı
      case 'rejected':
        return '#E91E63'; // Pembe (Reddedildi durumu için)
      default:
        return '#9E9E9E'; // Gri
    }
  };

  // Duruma göre ikon döndüren yardımcı fonksiyonu güncelle
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'completed':
        return <CompletedIcon sx={{ color: getStatusColor(status) }} />;
      case 'accepted':
      case 'assigned':
        return <TaskIcon sx={{ color: getStatusColor(status) }} />;
      case 'started':
        return <StartedIcon sx={{ color: getStatusColor(status) }} />;
      case 'waiting':
      case 'pending':
        return <PendingIcon sx={{ color: getStatusColor(status) }} />;
      case 'missed':
        return <AssignmentIcon sx={{ color: getStatusColor(status) }} />;
      case 'rejected':
        return <CancelIcon sx={{ color: getStatusColor(status) }} />; // Reddedildi durumu için
      default:
        return <TaskIcon sx={{ color: getStatusColor(status) }} />;
    }
  };

  // Duruma göre etiket döndüren yardımcı fonksiyonu güncelle
  const getStatusLabel = (status: string): string => {
    switch (status) {
      case 'completed':
        return t('tasks.status.completed');
      case 'accepted':
        return t('tasks.status.accepted');
      case 'assigned':
        return t('tasks.status.assigned');
      case 'started':
        return t('tasks.status.started');
      case 'waiting':
        return t('tasks.status.waiting');
      case 'pending':
        return t('tasks.status.pending');
      case 'missed':
        return t('tasks.status.missed');
      case 'rejected':
        return t('tasks.status.rejected');
      default:
        return t('tasks.status.unknown');
    }
  };

  // Filtreleme handler'ları
  const handleStatusFilterChange = (event: SelectChangeEvent) => {
    setStatusFilter(event.target.value);
  };

  // Personel filtresi için handler - Autocomplete için uygun hale getirildi
  const handlePersonnelFilterChange = (_event: React.SyntheticEvent, newValue: any) => {
    setPersonnelFilter(newValue?.id || 'all');
  };

  // Görev arama metni değişikliği için handler
  const handleTaskSearchTermChange = (value: string) => {
    setTaskSearchTerm(value);
  };

  // Filtreleri göster/gizle için handler
  const handleToggleFilters = () => {
    setShowFilters(!showFilters);
  };

  // Grup filtresi için handler
  const handleGroupFilterChange = (_event: React.SyntheticEvent, newValue: any) => {
    setGroupFilter(newValue ? newValue.id : 'all');
  };

  // Şube filtresi için handler
  const handleBranchFilterChange = (event: SelectChangeEvent) => {
    setBranchFilter(event.target.value);
  };

  // Filtrelenmiş görev listesini hesapla
  const filteredTasks = useMemo(() => {
    let result = [...tasks];
    
    // Eğer branchId verilmişse, sadece o şubeye ait görevleri göster
    if (branchId) {
      result = result.filter(task => {
        // branchesId bir nesne olabilir veya string olabilir
        if (typeof task.branchesId === 'object' && task.branchesId !== null) {
          // Nesne durumunda, anahtarlarını kontrol et
          return Object.keys(task.branchesId).includes(branchId);
        } else {
          // String durumunda direk karşılaştır
          return task.branchesId === branchId;
        }
      });
      
      // Tamamlanan görevleri de şubeye göre filtrele
      if (statusFilter === 'completed') {
        const filteredCompletedTasks = completedTasks.filter(task => {
          if (typeof task.branchesId === 'object' && task.branchesId !== null) {
            return Object.keys(task.branchesId).includes(branchId);
          } else {
            return task.branchesId === branchId;
          }
        });
        result = [
          ...result.filter(task => task.status === 'completed'),
          ...filteredCompletedTasks
        ];
      } else if (statusFilter === 'missed') {
        // Kaçırılan görevleri de şubeye göre filtrele
        const filteredMissedTasks = missedTasks.filter(task => {
          if (typeof task.branchesId === 'object' && task.branchesId !== null) {
            return Object.keys(task.branchesId).includes(branchId);
          } else {
            return task.branchesId === branchId;
          }
        });
        result = [
          ...result.filter(task => task.status === 'missed'),
          ...filteredMissedTasks
        ];
      }
    } else {
      // Şube ID'si verilmemişse normal filtrele
      if (statusFilter === 'completed') {
        // Ana görev listesindeki tamamlanan görevler + veritabanındaki tamamlanan görevler
        result = [
          ...result.filter(task => task.status === 'completed'),
          ...completedTasks
        ];
      } else if (statusFilter === 'missed') {
        // Ana görev listesindeki kaçırılan görevler + veritabanındaki kaçırılan görevler
        result = [
          ...result.filter(task => task.status === 'missed'),
          ...missedTasks
        ];
      } else if (statusFilter === 'rejected') {
        // Reddedilen görevleri filtrele
        result = result.filter(task => task.status === 'rejected');
      } else if (statusFilter !== 'all') {
        // Diğer durumlar için normal filtreleme
        result = result.filter(task => task.status === statusFilter);
      }
    }
    
    // Personel filtresi uygulanıyor
    if (personnelFilter !== 'all') {
      result = result.filter(task => task.personnelId === personnelFilter);
    }

    // Görev arama filtresi uygulanıyor
    if (taskSearchTerm !== '') {
      result = result.filter(task => 
        task.name.toLowerCase().includes(taskSearchTerm.toLowerCase()) ||
        task.description.toLowerCase().includes(taskSearchTerm.toLowerCase())
      );
    }
    
    // Grup filtresi uygulanıyor
    if (groupFilter !== 'all') {
      result = result.filter(task => task.groupId === groupFilter);
    }
    
    // Şube filtresi uygulanıyor
    if (branchFilter !== 'all') {
      if (branchFilter === 'unassigned') {
        // Şubesi olmayan görevleri filtrele
        result = result.filter(task => !task.branchesId);
      } else {
        // Belirli şubeye atanmış görevleri filtrele
        result = result.filter(task => {
          if (typeof task.branchesId === 'object' && task.branchesId !== null) {
            return Object.keys(task.branchesId).includes(branchFilter);
          } else {
            return task.branchesId === branchFilter;
          }
        });
      }
    }
    
    return result;
  }, [tasks, completedTasks, missedTasks, statusFilter, personnelFilter, taskSearchTerm, groupFilter, branchId, branchFilter]);

  // Veri işleme fonksiyonu — Faz 5 DILIM 3: SQL TaskDto[] + CompanyCompletionDto[] tüketir.
  const processData = (
    sqlTasks: TaskDto[],
    personnelData: any,
    completions: CompanyCompletionDto[] = [],
    groups: LegacyTaskGroup[] = []
  ) => {
    // Grup id (SQL int) → legacyFirebaseKey + ad eşlemeleri (filtre/gösterim uyumu).
    const groupKeyById = new Map<number, string>();
    const groupNameById = new Map<number, string>();
    groups.forEach((g) => {
      groupKeyById.set(g.sqlId, g.id);
      groupNameById.set(g.sqlId, g.name);
    });

    // Görev listesini hazırla (single + daily)
    const tasksList = (sqlTasks || []).map((tk) => {
      const personnelId = tk.personnelFirebaseUid || '';
      const personnelInfo = personnelData[personnelId] || {};
      const groupKey = tk.groupId != null ? (groupKeyById.get(tk.groupId) || String(tk.groupId)) : null;
      return {
        id: tk.id, // SQL int id
        name: tk.name || 'İsimsiz Görev',
        description: tk.description || '',
        status: tk.status || 'pending',
        createdAt: tk.createdAt ? new Date(tk.createdAt).getTime() : Date.now(),
        personnelId: personnelId,
        personnelName: personnelInfo.name || 'Atanmamış',
        isRecurring: tk.isRecurring || false,
        completionType: tk.completionType || 'button',
        dailyRepetitions: tk.dailyRepetitions || 1,
        startTolerance: tk.startTolerance || 15,
        repetitionTimes: parseStringArray(tk.repetitionTimes),
        completedAt: tk.completedAt ? new Date(tk.completedAt).getTime() : null,
        groupId: groupKey, // legacyFirebaseKey (filtre/grup eşlemesi korunur)
        groupName: tk.groupId != null ? (groupNameById.get(tk.groupId) || '') : '',
        branchesId: tk.branchesId || null,
        deadline: tk.deadline || null,
        startDate: tk.startDate || null,
        wasDelayed: tk.wasDelayed || false,
        delayReason: tk.delayReason || null,
        completionPhotoUrl: tk.completionPhotoUrl || null,
        imageUrls: parseStringArray(tk.imageUrls),
        rejectReason: tk.rejectReason || null,
        rejectedAt: tk.rejectedAt ? new Date(tk.rejectedAt).getTime() : null,
        rejectedBy: tk.rejectedByUid || null,
        acceptedAt: tk.acceptedAt ? new Date(tk.acceptedAt).getTime() : null,
        startedAt: tk.startedAt ? new Date(tk.startedAt).getTime() : null,
        companyId: tk.companyId,
        legacyFirebaseKey: tk.legacyFirebaseKey || null,
      };
    });

    // Görevleri oluşturulma tarihine göre sırala (yeniden eskiye)
    const sortedTasks = [...tasksList].sort((a, b) => b.createdAt - a.createdAt);
    setTasks(sortedTasks);
    
    // Tamamlama kayıtları (SQL completions) → Tamamlanan/Kaçırılan listeleri.
    const taskById = new Map<number, any>();
    sortedTasks.forEach((tk) => taskById.set(tk.id, tk));

    const completedTasksList: any[] = [];
    const missedTasksList: any[] = [];

    (completions || []).forEach((c) => {
      const orig = taskById.get(c.taskId);
      const personnelId = c.personnelFirebaseUid || orig?.personnelId || '';
      const personnelInfo = personnelData[personnelId] || {};

      // Şube: önce görevden, sonra completion'dan, sonra personelden.
      let branchesId: string | null =
        c.taskBranchesId || (orig ? orig.branchesId : null) || null;
      if (!branchesId && personnelInfo.branchesId) {
        branchesId = normalizeBranchesId(personnelInfo.branchesId);
      }

      const date = c.taskDate; // yyyy-MM-dd
      const time = c.taskTime; // HH:mm
      const personnelName =
        personnelInfo.name ||
        `${c.personnelFirstName || ''} ${c.personnelLastName || ''}`.trim() ||
        'Atanmamış';
      const deviceInfo =
        c.devicePlatform || c.deviceUserAgent
          ? { platform: c.devicePlatform || null, userAgent: c.deviceUserAgent || null }
          : null;
      const completionLocation =
        c.locationLat != null || c.locationLng != null
          ? { lat: c.locationLat ?? null, lng: c.locationLng ?? null, accuracy: c.locationAccuracy ?? null }
          : null;

      const base = {
        id: `${c.taskId}_${date}_${time}`,
        originalTaskId: c.taskId,
        name: c.taskName || orig?.name || 'İsimsiz Görev',
        description: c.taskDescription || orig?.description || '',
        createdAt: orig?.createdAt || (c.createdAt ? new Date(c.createdAt).getTime() : Date.now()),
        personnelId,
        personnelName,
        isRecurring: orig ? orig.isRecurring : true,
        completionType: orig?.completionType || 'button',
        repetitionTimes: [time],
        fromDatabase: true,
        branchesId,
        deviceInfo,
        deadline: orig?.deadline || c.taskDeadline || null,
        startDate: orig?.startDate || c.taskStartDate || null,
        completionPhotoUrl: c.completionPhotoUrl || null,
        completionLocation,
      };

      if (c.status === 'completed') {
        completedTasksList.push({
          ...base,
          status: 'completed',
          completedAt: c.completedAt
            ? new Date(c.completedAt).getTime()
            : new Date(`${date} ${time}`).getTime(),
          completionDate: date,
          completionTime: time,
          wasDelayed: false,
          delayReason: null,
          rejectReason: null,
          rejectedAt: null,
          rejectedBy: null,
        });
      } else if (c.status === 'missed') {
        missedTasksList.push({
          ...base,
          status: 'missed',
          missedAt: c.missedAt
            ? new Date(c.missedAt).getTime()
            : new Date(`${date} ${time}`).getTime(),
          missedDate: date,
          missedTime: time,
          wasDelayed: false,
          delayReason: c.missedReason || null,
          rejectReason: null,
          rejectedAt: null,
          rejectedBy: null,
        });
      }
      // status === 'started' (devam eden) bu sekmelerde gösterilmez.
    });

    setCompletedTasks(completedTasksList.sort((a, b) => b.completedAt - a.completedAt));
    setMissedTasks(missedTasksList.sort((a, b) => b.missedAt - a.missedAt));

    // Personel listesini hazırla (hasTask bayrağı kaldırıldı — SQL'den türetilir)
    const personnelList = personnelData ? Object.entries(personnelData)
      .filter(([_, data]: [string, any]) => !data.isDeleted) // Silinen personelleri filtrele
      .map(([id, data]: [string, any]) => {
        return {
          id,
          name: data.name || 'İsimsiz Personel',
          branchesId: normalizeBranchesId(data.branchesId), // Şube ID'sini ekle
          email: data.email || '',
          phone: data.phone || '',
        };
      }) : [];
    
    setPersonnel(personnelList);
  };

  // Component mount olduğunda veri yükleme
  useEffect(() => {
    const loadData = async () => {
      try {
        console.time('⏱️ Tasks - Total Load Time');
        setLoading(true);
        
        // Faz 5 DILIM 3: companyId AuthContext'ten (RTDB users/{uid} okuması kaldırıldı).
        const companyId = userDetails?.companyId || null;
        setCompanyId(companyId);

        if (!companyId) {
          setLoading(false);
          return;
        }

        // SQL sayfalı çekim yardımcıları (taskApi X-Company-Id header'ı otomatik gönderir)
        const fetchAllTasksOfType = async (type: string): Promise<TaskDto[]> => {
          const acc: TaskDto[] = [];
          let page = 1;
          for (;;) {
            const res = await taskDataService.listTasks({ taskType: type, page, pageSize: 200 });
            acc.push(...res.items);
            if (res.items.length === 0 || page >= (res.totalPages || 1)) break;
            page++;
          }
          return acc;
        };
        const fetchAllCompletions = async (): Promise<CompanyCompletionDto[]> => {
          const acc: CompanyCompletionDto[] = [];
          let page = 1;
          for (;;) {
            const res = await taskDataService.listCompletions({ page, pageSize: 1000 });
            acc.push(...res.items);
            if (res.items.length === 0 || page >= (res.totalPages || 1)) break;
            page++;
          }
          return acc;
        };

        // Tüm verileri paralel olarak çekelim (görev verisi SQL'den)
        console.time('⏱️ Tasks - Fetch All Data');
        const [personnelData, singleTasks, dailyTasks, completionsData, groupsData] = await Promise.all([
          (async () => {
            // Faz 3: personel listesi SQL'den (personnelDataService); downstream uid-anahtarli harita bekliyor.
            const sqlPersonnel = await getPersonnelSql(companyId);
            const data: Record<string, any> = {};
            (sqlPersonnel || []).forEach((p: any) => { if (p?.id) data[p.id] = p; });
            return data;
          })(),
          fetchAllTasksOfType('single'),
          fetchAllTasksOfType('daily'),
          fetchAllCompletions(),
          taskDataService.listGroupsLegacy(),
        ]);
        console.timeEnd('⏱️ Tasks - Fetch All Data');

        // Görev gruplarını işle — SQL'den (taskDataService) RTDB-uyumlu sekilde geliyor.
        setTaskGroups(Array.isArray(groupsData) ? groupsData : []);

        // Verileri işle (single + daily birleştir)
        console.time('⏱️ Tasks - Process All Data');
        processData(
          [...(singleTasks || []), ...(dailyTasks || [])],
          personnelData,
          completionsData,
          groupsData
        );
        console.timeEnd('⏱️ Tasks - Process All Data');

      } catch (error) {
        console.error('Görev verilerini yüklerken hata:', error);
      } finally {
        setLoading(false);
        console.timeEnd('⏱️ Tasks - Total Load Time');
      }
    };
    
    loadData();
  }, [userDetails?.companyId, refreshNonce]); // useEffect sonu

  // Görev silme fonksiyonu — Faz 5 DILIM 3: normal/günlük SQL (taskDataService)
  const handleDeleteTask = async (taskId: string | number, personnelId: string) => {
    if (!companyId) {
      throw new Error(t('tasks.errors.companyNotFound'));
    }

    try {
      // Eğer haftalık görevse, haftalık görev silme fonksiyonunu çağır
      if (taskType === 'weekly') {
        return handleDeleteWeeklyTask(String(taskId), personnelId);
      }
      
      // Eğer aylık görevse, aylık görev silme fonksiyonunu çağır
      if (taskType === 'monthly') {
        return handleDeleteMonthlyTask(String(taskId), personnelId);
      }
      
      // Normal + günlük görev: SQL'den sil
      await taskDataService.deleteTask(Number(taskId));
      // Listeyi yerelde güncelle
      setTasks((prev) => prev.filter((tk) => tk.id !== Number(taskId)));
    } catch (error) {
      console.error('Görev silinirken hata:', error);
      throw error; // Hata yönetimi için hatayı yeniden fırlat
    }
  };
  
  // Haftalık görev silme fonksiyonu
  const handleDeleteWeeklyTask = async (taskId: string, personnelId: string) => {
    if (!companyId) {
      throw new Error(t('tasks.errors.companyNotFound'));
    }

    try {
      // Faz 5 DILIM 4: haftalık görev SQL'den silinir (id = SQL int); slotlar cascade ile gider.
      await taskDataService.deleteTask(Number(taskId));
      // NOT: personel `hasTask` bayrağı SQL `personnelId` filtresiyle türetilir; RTDB yazımı yok.
      triggerRefresh();
    } catch (error) {
      console.error('Haftalık görev silinirken hata:', error);
      throw error;
    }
  };

  // Görev detaylarını gösterme fonksiyonu
  const handleShowTaskDetail = (task: any) => {
    // Tamamlanan veya Tamamlanmamış filtresi aktifse detay modalını açma
    if (statusFilter === 'completed' || statusFilter === 'missed') {
      return; // Detay modalını açmadan çık
    }
    
    setSelectedTask(task);
    setTaskDetailOpen(true);
  };

  // Yeni görev ekleme fonksiyonu
  const handleAddTask = async (taskData: {
    name: string;
    description: string;
    personnelId: string;
    completionType: string;
    isRecurring: boolean;
    repeatType: string;
    dailyRepetitions?: number;
    startTolerance: number;
    repetitionTimes?: string[];
    groupId?: string;
    weekDays?: number[];
    monthDay?: number;
    yearDate?: string;
    branchesId?: string; // Şube ID'si parametresi
    monthlyData?: {
      month: number;
      monthName: string;
      days: {
        day: number;
        dailyRepetitions: number;
        repetitionTimes: string[];
      }[];
    }[];
    deadline?: string; // Bitiş tarihi parametresi eklendi
    startDate?: string; // Başlangıç tarihi parametresi eklendi
    imageUrls?: string[]; // Normal görev görselleri (Storage URL'leri)
    requestCompletionPhoto?: boolean; // Tamamlamada foto iste
    canBeRejected?: boolean; // Reddedilebilir mi
  }) => {
    if (!companyId) {
      throw new Error(t('tasks.errors.companyNotFound'));
    }

    try {
      // Faz 5 DILIM 4: aylık görev SQL'e (taskDataService) — ay/gün izgarası slot olarak.
      if (taskData.isRecurring && taskData.repeatType === 'monthly' && taskData.monthlyData) {
        const groupSqlIdMonthly = taskData.groupId
          ? (taskGroups.find((g: any) => g.id === taskData.groupId)?.sqlId ?? null)
          : null;

        const createdMonthly = await taskDataService.createTask({
          taskType: 'monthly',
          name: taskData.name,
          description: taskData.description || null,
          personnelFirebaseUid: taskData.personnelId || null,
          branchesId: taskData.branchesId || null,
          groupId: groupSqlIdMonthly,
          isRecurring: true,
          completionType: taskData.completionType || 'button',
          startTolerance: taskData.startTolerance ?? 15,
          createdByUid: currentUser?.uid || null,
        });

        // Ay/gün slotları (MonthNumber 1-12, DayOfMonth 1-31).
        const monthlySlots = taskData.monthlyData.flatMap((monthData) =>
          monthData.days.map((dayData) => ({
            monthNumber: monthData.month,
            dayOfMonth: dayData.day,
            dailyRepetitions: dayData.dailyRepetitions ?? 1,
            repetitionTimes: stringifyStringArray(dayData.repetitionTimes ?? []),
          }))
        );
        if (monthlySlots.length > 0) {
          await taskDataService.setSlots(createdMonthly.id, monthlySlots);
        }

        triggerRefresh();
        return; // Aylık görev SQL'e yazıldı
      }

      // Normal (single) + günlük (daily) görev → SQL (taskDataService)
      // taskData.groupId = grup legacyFirebaseKey; SQL int sqlId'ye çevir.
      const groupSqlId = taskData.groupId
        ? (taskGroups.find((g: any) => g.id === taskData.groupId)?.sqlId ?? null)
        : null;

      await taskDataService.createTask({
        taskType: taskData.isRecurring ? 'daily' : 'single',
        name: taskData.name,
        description: taskData.description || null,
        personnelFirebaseUid: taskData.personnelId || null,
        branchesId: taskData.branchesId || null,
        groupId: groupSqlId,
        isRecurring: !!taskData.isRecurring,
        completionType: taskData.completionType || 'button',
        startTolerance: taskData.isRecurring ? (taskData.startTolerance ?? 15) : null,
        dailyRepetitions: taskData.isRecurring ? (taskData.dailyRepetitions ?? null) : null,
        repetitionTimes: taskData.isRecurring ? stringifyStringArray(taskData.repetitionTimes ?? []) : null,
        requestCompletionPhoto: !!taskData.requestCompletionPhoto,
        canBeRejected: !!taskData.canBeRejected,
        deadline: taskData.deadline || null,
        startDate: taskData.startDate || null,
        imageUrls: taskData.imageUrls && taskData.imageUrls.length > 0
          ? stringifyStringArray(taskData.imageUrls)
          : null,
        createdByUid: currentUser?.uid || null,
      });

      // Listeyi yenile
      triggerRefresh();
    } catch (error) {
      console.error('Görev eklenirken hata:', error);
      throw error;
    }
  };
  
  // Haftalık görev ekleme fonksiyonu
  const handleAddWeeklyTask = async (taskData: {
    name: string;
    description: string;
    personnelId: string;
    completionType: string;
    weekDays: {
      day: number;
      dailyRepetitions: number;
      repetitionTimes: string[];
    }[];
    startTolerance: number;
    groupId?: string;
    branchesId?: string; // Şube ID'si parametresi
  }) => {
    if (!companyId) {
      throw new Error(t('tasks.errors.companyNotFound'));
    }

    try {
      // Faz 5 DILIM 4: haftalık görev SQL'e (taskDataService) — gün/saat izgarası slot olarak.
      // grup legacyFirebaseKey → SQL int sqlId.
      const groupSqlId = taskData.groupId
        ? (taskGroups.find((g: any) => g.id === taskData.groupId)?.sqlId ?? null)
        : null;

      const created = await taskDataService.createTask({
        taskType: 'weekly',
        name: taskData.name,
        description: taskData.description || null,
        personnelFirebaseUid: taskData.personnelId || null,
        branchesId: taskData.branchesId || null,
        groupId: groupSqlId,
        isRecurring: true,
        completionType: taskData.completionType || 'button',
        startTolerance: taskData.startTolerance ?? 15,
        createdByUid: currentUser?.uid || null,
      });

      // Gün-bazlı tekrar slotları (DayOfWeek 0-6).
      const slots = (taskData.weekDays || []).map((d) => ({
        dayOfWeek: d.day,
        dailyRepetitions: d.dailyRepetitions ?? 1,
        repetitionTimes: stringifyStringArray(d.repetitionTimes ?? []),
      }));
      if (slots.length > 0) {
        await taskDataService.setSlots(created.id, slots);
      }

      // NOT: personel `hasTask` bayrağı SQL `personnelId` filtresiyle türetilir; RTDB yazımı yok.
      triggerRefresh();
    } catch (error) {
      console.error('Haftalık görev eklenirken hata:', error);
      throw error;
    }
  };

  // Görevdeki personeli değiştirme fonksiyonu
  const handleUpdatePersonnel = async (taskId: string | number, newPersonnelId: string): Promise<void> => {
    if (!companyId) {
      throw new Error(t('tasks.errors.companyNotFound'));
    }

    try {
      // Faz 5 DILIM 3: normal/günlük görev devri SQL (taskDataService).
      await taskDataService.changeTaskAssignee(Number(taskId), newPersonnelId || null);
      // Yerelde güncelle + listeyi tazele
      setTasks((prev) => prev.map((tk) =>
        tk.id === Number(taskId)
          ? { ...tk, personnelId: newPersonnelId, personnelName: personnel.find((p) => p.id === newPersonnelId)?.name || tk.personnelName }
          : tk
      ));
      triggerRefresh();
    } catch (error) {
      console.error('Personel güncellenirken hata:', error);
      throw error;
    }
  };

  // Tekrarlı görevlerin durumlarını kontrol et ve güncelle
  const checkRecurringTaskTimes = async () => {
    if (isCheckingTasks) return;
    
    try {
      setIsCheckingTasks(true);
      
      const statusMap: Record<string, any> = {};
      
      // Her görev için tekrarlanan zamanları kontrol et
      for (const task of tasks) {
        if (task.isRecurring && task.repetitionTimes && task.repetitionTimes.length > 0) {
          
          // Tekrarlanan her zaman için durumu kontrol et
          for (const timeString of task.repetitionTimes) {
            
            // TaskTimeService kullanarak zamanları kontrol et
            const singleTimeResult = await TaskTimeService.checkRecurringTaskTime(
              [timeString], // Sadece bu zamanı kontrol et
              task.startTolerance || 15,
              task.status
            );
            
            // Renk belirle
            const color = TaskTimeService.getTaskTimeColor(singleTimeResult.status, task.status);
            
            statusMap[`${task.id}_${timeString}`] = {
              status: singleTimeResult.status,
              color,
              activeTime: timeString
            };
          }
        }
      }
      
      setTaskTimeStatuses(statusMap);
      
    } catch (error) {
      console.error('Görev zamanları kontrol edilirken hata:', error);
    } finally {
      setIsCheckingTasks(false);
    }
  };

  // Component mount olduğunda ve görev/şirket ID'si değiştiğinde kontrol yap
  useEffect(() => {
    if (companyId && tasks.length > 0 && !loading) {
      checkRecurringTaskTimes();
      
      // Her dakika kontrol yap
      const interval = setInterval(() => {
        checkRecurringTaskTimes();
      }, 60000); // 60 saniye
      
      return () => clearInterval(interval);
    }
  }, [companyId, tasks, loading]);

  // Görev zamanı rengi belirle
  const getTaskTimeColor = (task: any, timeString: string): string => {
    const key = `${task.id}_${timeString}`;
    if (taskTimeStatuses[key]) {
      return taskTimeStatuses[key].color;
    }
    return '#9E9E9E'; // Varsayılan gri
  };

  // Görev zamanı durumu belirle
  const getTaskTimeStatus = (task: any, timeString: string): string => {
    const key = `${task.id}_${timeString}`;
    if (taskTimeStatuses[key]) {
      return taskTimeStatuses[key].status;
    }
    return TaskTimeStatus.notYetDue;
  };

  // QR Kod yazdırma modalını açma işlevi
  const handleOpenQrPrintModal = (task: any, event: React.MouseEvent) => {
    event.stopPropagation(); // Kart tıklama olayının tetiklenmesini engelle
    setSelectedTaskForQr(task);
    setQrPrintModalOpen(true);
  };

  // Excel dışa aktarma fonksiyonu
  const exportToExcel = async () => {
    try {
      // Excel workbook oluştur
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Görevler');
      
      // Sütun başlıklarını tanımla
      worksheet.columns = [
        { header: 'Durum', key: 'status', width: 15 },
        { header: 'Görev Adı', key: 'name', width: 30 },
        { header: 'Görev Saatleri', key: 'times', width: 30 },
        { header: 'Tarih', key: 'date', width: 20 },
        { header: 'Tolerans', key: 'tolerance', width: 12 },
        { header: 'Personel', key: 'personnel', width: 20 },
        { header: 'Açıklama', key: 'description', width: 40 }
      ];
      
      // Stil tanımlamaları
      const headerStyle = {
        font: { bold: true, color: { argb: 'FFFFFFFF' } },
        fill: { type: 'pattern' as const, pattern: 'solid' as const, fgColor: { argb: 'FF4F81BD' } },
        border: {
          top: { style: 'thin' as const },
          left: { style: 'thin' as const },
          bottom: { style: 'thin' as const },
          right: { style: 'thin' as const }
        }
      };
      
      // Başlık stilini uygula
      worksheet.getRow(1).eachCell(cell => {
        cell.style = headerStyle;
      });
      
      // Filtrelenmiş görev verilerini ekle
      filteredTasks.forEach(task => {
        // Görev saatleri
        const taskTimes = task.repetitionTimes && task.repetitionTimes.length > 0
          ? task.repetitionTimes.join(', ')
          : '-';
        
        // Tarih bilgisi
        let dateInfo = '-';
        if (task.status === 'completed') {
          dateInfo = task.fromDatabase && task.completionDate 
            ? task.completionDate 
            : (task.completedAt ? new Date(task.completedAt).toLocaleDateString('tr-TR') : '-');
        } else if (task.status === 'missed') {
          dateInfo = task.fromDatabase && task.missedDate 
            ? task.missedDate 
            : (task.missedAt ? new Date(task.missedAt).toLocaleDateString('tr-TR') : '-');
        }
        
        // Tolerans bilgisi
        const toleranceInfo = task.isRecurring ? `${task.startTolerance || 15} dk` : '-';
        
        // Satır ekleme
        worksheet.addRow({
          status: getStatusLabel(task.status),
          name: task.name,
          times: taskTimes,
          date: dateInfo,
          tolerance: toleranceInfo,
          personnel: task.personnelName || 'Atanmamış',
          description: task.description || ''
        });
      });
      
      // Zebrastripe (alternatif satır renklendirme)
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber > 1) { // başlığı atla
          const fillColor = rowNumber % 2 === 0 ? 'FFF2F2F2' : 'FFFFFFFF';
          row.eachCell(cell => {
            cell.style = {
              fill: { type: 'pattern' as const, pattern: 'solid' as const, fgColor: { argb: fillColor } },
              border: {
                top: { style: 'thin' as const },
                left: { style: 'thin' as const },
                bottom: { style: 'thin' as const },
                right: { style: 'thin' as const }
              }
            };
          });
        }
      });
      
      // Excel dosyasını oluştur ve indir
      const buffer = await workbook.xlsx.writeBuffer();
      const currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, '');
      saveAs(new Blob([buffer]), `Görevler_${currentDate}.xlsx`);
      
    } catch (error) {
      console.error('Excel dışa aktarma hatası:', error);
      alert('Excel dosyası oluşturulurken bir hata oluştu.');
    }
  };

  // Görev tipini değiştir
  const handleTaskTypeChange = (event: React.SyntheticEvent, newValue: 'normal' | 'team' | 'daily' | 'weekly' | 'monthly' | 'yearly' | 'takvim') => {
    setTaskType(newValue);
  };

  // Görünüm modu değiştiğinde localStorage'a kaydet
  const handleViewModeChange = (
    event: React.MouseEvent<HTMLElement>,
    newViewMode: 'card' | 'list' | null
  ) => {
    if (newViewMode !== null) {
      setViewMode(newViewMode);
      localStorage.setItem('tasksViewMode', newViewMode);
    }
  };

  // Aylık görev silme fonksiyonu
  const handleDeleteMonthlyTask = async (taskId: string, personnelId: string): Promise<void> => {
    if (!companyId) {
      throw new Error(t('tasks.errors.companyNotFound'));
    }

    try {
      // Faz 5 DILIM 4: aylık görev SQL'den silinir (id = SQL int); slotlar cascade ile gider.
      await taskDataService.deleteTask(Number(taskId));
      // NOT: personel `hasTask` bayrağı SQL `personnelId` filtresiyle türetilir; RTDB yazımı yok.
      triggerRefresh();
    } catch (error) {
      console.error('Aylık görev silinirken hata:', error);
      throw error;
    }
  };

  // Yıllık görev silme fonksiyonu — Faz 5 DILIM 2: SQL (taskDataService).
  const handleDeleteYearlyTask = async (taskId: string | number, personnelId: string): Promise<void> => {
    if (!companyId) {
      throw new Error(t('tasks.errors.companyNotFound'));
    }

    try {
      // Yillik plan SQL'den silinir (id = SQL int).
      await taskDataService.deleteYearlyPlan(Number(taskId));
      // NOT: personel `hasTask` bayragi DILIM 3'te SQL `personnelId` filtresiyle
      // turetilecek; bu nedenle burada RTDB personnel yazimi yapilmaz.
    } catch (error) {
      console.error('Yıllık görev silinirken hata:', error);
      throw error;
    }
  };

  // Sekmeye göre doğru veri setini döndüren fonksiyon
  const getTasksForExport = () => {
    switch(taskType) {
      case 'normal':
        return filteredTasks.filter(task => !task.isRecurring);
      case 'daily':
        return filteredTasks.filter(task => task.isRecurring);
      case 'weekly':
        return weeklyTasksData;
      case 'monthly':
        return monthlyTasksData;
      case 'yearly':
        return yearlyTasksData;
      case 'takvim':
        return filteredTasks; // Takvim görünümünde de filtrelenmiş görevleri döndür
      case 'team':
        return filteredTasks; // Ekip görünümünde de filtrelenmiş görevleri döndür
      default:
        return filteredTasks;
    }
  };

  // Weekly tasks bileşeni için callback
  const handleWeeklyTasksDataChange = (tasks: any[]) => {
    setWeeklyTasksData(tasks);
  };

  // Monthly tasks bileşeni için callback
  const handleMonthlyTasksDataChange = (tasks: any[]) => {
    setMonthlyTasksData(tasks);
  };

  // Yearly tasks bileşeni için callback
  const handleYearlyTasksDataChange = (tasks: any[]) => {
    setYearlyTasksData(tasks);
  };

  // Ekip oluşturma modalını açma handler'ı
  const handleOpenCreateTeamModal = () => {
    setCreateTeamModalOpen(true);
  };
    
  // Ekip görevi ekleme modalını açma handler'ı
  const handleOpenCreateTeamTaskModal = () => {
    setCreateTeamTaskModalOpen(true);
  };

  // Görünüm değiştirme işlevi
  const handleTeamDisplayModeChange = (
    event: React.MouseEvent<HTMLElement>,
    newMode: 'tasks' | 'teams' | null
  ) => {
    if (newMode !== null) {
      setTeamDisplayMode(newMode);
    }
  };

  // Red nedenini göstermek için modal açma işlevi
  const handleOpenRejectReasonModal = (task: any) => {
    setSelectedTask(task);
    setSelectedRejectReason(task.rejectReason || 'Reddedilme nedeni belirtilmemiş');
    setRejectReasonModalOpen(true);
  };

  // handleRenewTask fonksiyonunu ekle
  const handleRenewTask = async (taskId: string | number, adminNote: string): Promise<void> => {
    if (!companyId) {
      throw new Error(t('tasks.errors.companyNotFound'));
    }

    try {
      // Faz 5 DILIM 3: normal/günlük görev yenileme SQL (taskDataService).
      const id = Number(taskId);
      // Açıklamayı yönetici notu ile değiştir + reddetme kapat
      await taskDataService.updateTask(id, {
        description: adminNote,
        canBeRejected: false,
      });
      // Durumu 'renew' aksiyonu ile sıfırla (status → pending, renewedAt işaretlenir)
      await taskDataService.changeTaskStatus(id, {
        action: 'renew',
        byUid: currentUser?.uid || null,
      });
      triggerRefresh();
    } catch (error) {
      console.error('Görev yenilenirken hata:', error);
      throw error;
    }
  };

  return (
    <ScrollableContent>
      <HeaderContainer>
        <Typography variant="h4" component="h1" fontWeight="bold" color="primary" sx={{ py: 1 }}>
          {isManager ? t('tasks.branchTasks') : t('tasks.pageTitle')}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleViewModeChange}
            aria-label="görünüm modu"
            size="small"
          >
            <ToggleButton value="card" aria-label="kart görünümü">
              <ViewModuleIcon />
            </ToggleButton>
            <ToggleButton value="list" aria-label="liste görünümü">
              <ViewListIcon />
            </ToggleButton>
          </ToggleButtonGroup>
          <GuideButton guideKey="tasks.list" color="info" size="small" sx={{ width: 36, height: 36 }} />
          <ExcelExportButton 
            tasks={getTasksForExport()}
            taskType={taskType}
            loading={loading}
            getStatusLabel={getStatusLabel}
          />
          <Button
            variant="contained"
            color="success"
            startIcon={<CategoryIcon />}
            onClick={() => setTaskGroupsModalOpen(true)}
            sx={{ borderRadius: 2 }}
          >
            {t('tasks.addGroup')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() => setAddTaskModalOpen(true)}
            sx={{ borderRadius: 2 }}
          >
            {t('tasks.newTask')}
          </Button>
        </Box>
      </HeaderContainer>

      {/* Görev Tipi Sekmeleri */}
      <Box sx={{ mb: showFilters ? 1 : 2 }}>
        <Tabs 
          value={taskType} 
          onChange={handleTaskTypeChange} 
          variant="fullWidth"
          sx={{ 
            borderBottom: 1, 
            borderColor: 'divider',
            '& .MuiTab-root': {
              py: 1.5
            }
          }}
        >
          <Tab 
            value="normal" 
            label={t('tasks.taskTypes.normal')} 
            icon={<ListAltIcon />} 
            iconPosition="start"
          />
          <Tab 
            value="team" 
            label={t('tasks.taskTypes.team')} 
            icon={<GroupsIcon />} 
            iconPosition="start"
          />
          <Tab 
            value="daily" 
            label={t('tasks.taskTypes.daily')} 
            icon={<TodayIcon />} 
            iconPosition="start"
          />
          <Tab 
            value="weekly" 
            label={t('tasks.taskTypes.weekly')} 
            icon={<WeekIcon />} 
            iconPosition="start"
          />
          <Tab 
            value="monthly" 
            label={t('tasks.taskTypes.monthly')} 
            icon={<MonthIcon />} 
            iconPosition="start"
          />
          <Tab 
            value="yearly" 
            label={t('tasks.taskTypes.yearly')} 
            icon={<YearIcon />} 
            iconPosition="start"
          />
          {/* Takvim tabını sadece manager olmayan kullanıcılar için göster */}
          {!isManager && (
            <Tab 
              value="takvim" 
              label={t('tasks.taskTypes.calendar')} 
              icon={<TakvimIcon />} 
              iconPosition="start"
            />
          )}
        </Tabs>
      </Box>

      {/* Normal Görevler İçeriği */}
      {taskType === 'normal' && (
        <>
          <TasksFilter
            statusFilter={statusFilter}
            personnelFilter={personnelFilter}
            groupFilter={groupFilter}
            taskSearchTerm={taskSearchTerm}
            showFilters={showFilters}
            personnel={personnel}
            taskGroups={taskGroups}
            onStatusFilterChange={handleStatusFilterChange}
            onPersonnelFilterChange={handlePersonnelFilterChange}
            onGroupFilterChange={handleGroupFilterChange}
            onTaskSearchTermChange={handleTaskSearchTermChange}
            onToggleFilters={handleToggleFilters}
            taskType={taskType}
            branches={branches}
            branchFilter={branchFilter}
            onBranchFilterChange={handleBranchFilterChange}
          />
          
          <TasksNormalView
            loading={loading}
            filteredTasks={filteredTasks}
            statusFilter={statusFilter}
            viewMode={viewMode}
            onShowTaskDetail={handleShowTaskDetail}
            onOpenQrPrintModal={handleOpenQrPrintModal}
            getStatusColor={getStatusColor}
            getStatusIcon={getStatusIcon}
            getStatusLabel={getStatusLabel}
            getTaskTimeColor={getTaskTimeColor}
            companyId={companyId}
            onOpenDeviceModal={handleOpenDeviceModal}
            setAddTaskModalOpen={setAddTaskModalOpen}
            LoadingContainer={LoadingContainer}
            NoDataBox={NoDataBox}
            branches={branches}
            onRenewTask={handleRenewTask}
          />
        </>
      )}

      {/* Ekip Görevleri İçeriği */}
      {taskType === 'team' && (
        <>
          <TasksFilter
            statusFilter={statusFilter}
            personnelFilter={personnelFilter}
            groupFilter={groupFilter}
            taskSearchTerm={taskSearchTerm}
            showFilters={showFilters}
            personnel={personnel}
            taskGroups={taskGroups}
            onStatusFilterChange={handleStatusFilterChange}
            onPersonnelFilterChange={handlePersonnelFilterChange}
            onGroupFilterChange={handleGroupFilterChange}
            onTaskSearchTermChange={handleTaskSearchTermChange}
            onToggleFilters={handleToggleFilters}
            taskType={taskType}
            onCreateTeam={handleOpenCreateTeamModal}
            onCreateTeamTask={handleOpenCreateTeamTaskModal}
            displayMode={teamDisplayMode}
            onDisplayModeChange={handleTeamDisplayModeChange}
            branches={branches}
            branchFilter={branchFilter}
            onBranchFilterChange={handleBranchFilterChange}
          />
          
          <TeamTasks
            companyId={companyId}
            statusFilter={statusFilter}
            personnelFilter={personnelFilter}
            taskSearchTerm={taskSearchTerm}
            viewMode={viewMode}
            loading={loading}
            onDisplayModeChange={handleTeamDisplayModeChange}
            displayMode={teamDisplayMode}
            onCreateTeamTask={handleOpenCreateTeamTaskModal}
          />
        </>
      )}

      {/* Günlük Görevler İçeriği */}
      {taskType === 'daily' && (
        <>
          <TasksFilter
            statusFilter={statusFilter}
            personnelFilter={personnelFilter}
            groupFilter={groupFilter}
            taskSearchTerm={taskSearchTerm}
            showFilters={showFilters}
            personnel={personnel}
            taskGroups={taskGroups}
            onStatusFilterChange={handleStatusFilterChange}
            onPersonnelFilterChange={handlePersonnelFilterChange}
            onGroupFilterChange={handleGroupFilterChange}
            onTaskSearchTermChange={handleTaskSearchTermChange}
            onToggleFilters={handleToggleFilters}
            taskType={taskType}
            branches={branches}
            branchFilter={branchFilter}
            onBranchFilterChange={handleBranchFilterChange}
          />

          {/* Kaçırılan Görevler Servisi Uyarısı */}
          <Alert 
            severity="error" 
            sx={{ 
              mb: 2,
              mx: 3,
              fontSize: '0.85rem',
              '& .MuiAlert-message': {
                width: '100%',
                textAlign: 'center',
                fontSize: '0.85rem'
              }
            }}
          >
            ⚠️ ÖNEMLİ: Son 30 gün içinde sisteme giriş yapmazsanız, kaçırılan görevler servisi otomatik görev kontrolü yapmayacaktır.
          </Alert>

          <TasksDailyView
            loading={loading}
            filteredTasks={filteredTasks}
            statusFilter={statusFilter}
            personnelFilter={personnelFilter}
            viewMode={viewMode}
            onShowTaskDetail={handleShowTaskDetail}
            onOpenQrPrintModal={handleOpenQrPrintModal}
            getStatusColor={getStatusColor}
            getStatusIcon={getStatusIcon}
            getStatusLabel={getStatusLabel}
            getTaskTimeColor={getTaskTimeColor}
            companyId={companyId}
            onOpenDeviceModal={handleOpenDeviceModal}
            setAddTaskModalOpen={setAddTaskModalOpen}
            branches={branches}
            onOpenTaskLocationModal={handleOpenTaskLocationModal} // Propu ekle
          />
        </>
      )}

      {/* Haftalık Görevler İçeriği */}
      {taskType === 'weekly' && (
        <>
          <TasksFilter
            statusFilter={statusFilter}
            personnelFilter={personnelFilter}
            groupFilter={groupFilter}
            taskSearchTerm={taskSearchTerm}
            showFilters={showFilters}
            personnel={personnel}
            taskGroups={taskGroups}
            onStatusFilterChange={handleStatusFilterChange}
            onPersonnelFilterChange={handlePersonnelFilterChange}
            onGroupFilterChange={handleGroupFilterChange}
            onTaskSearchTermChange={handleTaskSearchTermChange}
            onToggleFilters={handleToggleFilters}
            taskType={taskType}
            branches={branches}
            branchFilter={branchFilter}
            onBranchFilterChange={handleBranchFilterChange}
          />

          {/* Kaçırılan Görevler Servisi Uyarısı */}
          <Alert 
            severity="error" 
            sx={{ 
              mb: 2,
              mx: 3,
              fontSize: '0.85rem',
              '& .MuiAlert-message': {
                width: '100%',
                textAlign: 'center',
                fontSize: '0.85rem'
              }
            }}
          >
            ⚠️ ÖNEMLİ: Son 30 gün içinde sisteme giriş yapmazsanız, kaçırılan görevler servisi otomatik görev kontrolü yapmayacaktır.
          </Alert>

          <WeeklyTasks
            companyId={companyId}
            statusFilter={statusFilter}
            personnelFilter={personnelFilter}
            taskSearchTerm={taskSearchTerm}
            viewMode={viewMode}
            personnel={personnel}
            onShowTaskDetail={handleShowTaskDetail}
            onOpenQrPrintModal={handleOpenQrPrintModal}
            getStatusColor={getStatusColor}
            getStatusIcon={getStatusIcon}
            getStatusLabel={getStatusLabel}
            getTaskTimeColor={getTaskTimeColor}
            onDeleteTask={handleDeleteWeeklyTask}
            onWeeklyTasksDataChange={handleWeeklyTasksDataChange}
            branchId={branchId}
            isManager={isManager}
            reloadKey={refreshNonce}
          />
        </>
      )}

      {/* Aylık Görevler İçeriği */}
      {taskType === 'monthly' && (
        <>
          <TasksFilter
            statusFilter={statusFilter}
            personnelFilter={personnelFilter}
            groupFilter={groupFilter}
            taskSearchTerm={taskSearchTerm}
            showFilters={showFilters}
            personnel={personnel}
            taskGroups={taskGroups}
            onStatusFilterChange={handleStatusFilterChange}
            onPersonnelFilterChange={handlePersonnelFilterChange}
            onGroupFilterChange={handleGroupFilterChange}
            onTaskSearchTermChange={handleTaskSearchTermChange}
            onToggleFilters={handleToggleFilters}
            taskType={taskType}
            branches={branches}
            branchFilter={branchFilter}
            onBranchFilterChange={handleBranchFilterChange}
          />

          {/* Kaçırılan Görevler Servisi Uyarısı */}
          <Alert 
            severity="error" 
            sx={{ 
              mb: 2,
              mx: 3,
              fontSize: '0.85rem',
              '& .MuiAlert-message': {
                width: '100%',
                textAlign: 'center',
                fontSize: '0.85rem'
              }
            }}
          >
            ⚠️ ÖNEMLİ: Son 30 gün içinde sisteme giriş yapmazsanız, kaçırılan görevler servisi otomatik görev kontrolü yapmayacaktır.
          </Alert>

          <MonthlyTasks
            companyId={companyId}
            statusFilter={statusFilter}
            personnelFilter={personnelFilter}
            taskSearchTerm={taskSearchTerm}
            viewMode={viewMode}
            personnel={personnel}
            onShowTaskDetail={handleShowTaskDetail}
            onOpenQrPrintModal={handleOpenQrPrintModal}
            getStatusColor={getStatusColor}
            getStatusIcon={getStatusIcon}
            getStatusLabel={getStatusLabel}
            getTaskTimeColor={getTaskTimeColor}
            onDeleteTask={handleDeleteMonthlyTask}
            onMonthlyTasksDataChange={handleMonthlyTasksDataChange}
            branchId={branchId}
            isManager={isManager}
            reloadKey={refreshNonce}
          />
        </>
      )}

      {/* Yıllık Görevler İçeriği */}
      {taskType === 'yearly' && (
        <>
          <TasksFilter
            statusFilter={statusFilter}
            personnelFilter={personnelFilter}
            groupFilter={groupFilter}
            taskSearchTerm={taskSearchTerm}
            showFilters={showFilters}
            personnel={personnel}
            taskGroups={taskGroups}
            onStatusFilterChange={handleStatusFilterChange}
            onPersonnelFilterChange={handlePersonnelFilterChange}
            onGroupFilterChange={handleGroupFilterChange}
            onTaskSearchTermChange={handleTaskSearchTermChange}
            onToggleFilters={handleToggleFilters}
            taskType={taskType}
            branches={branches}
            branchFilter={branchFilter}
            onBranchFilterChange={handleBranchFilterChange}
          />

          <YearlyTasks
            companyId={companyId}
            statusFilter={statusFilter}
            personnelFilter={personnelFilter}
            taskSearchTerm={taskSearchTerm}
            viewMode={viewMode}
            personnel={personnel}
            onShowTaskDetail={handleShowTaskDetail}
            onOpenQrPrintModal={handleOpenQrPrintModal}
            getStatusColor={getStatusColor}
            getStatusIcon={getStatusIcon}
            getStatusLabel={getStatusLabel}
            getTaskTimeColor={getTaskTimeColor}
            onDeleteTask={handleDeleteYearlyTask}
            onYearlyTasksDataChange={handleYearlyTasksDataChange}
            branchId={branchId}
            isManager={isManager}
          />
        </>
      )}

      {taskType === 'takvim' && (
        <Takvim
          companyId={companyId}
          reloadKey={refreshNonce}
        />
      )}

      {/* Görev Detay Modalı - hem yöneticiler hem normal kullanıcılar görebilir */}
      <TaskDetailModal
        open={taskDetailOpen}
        onClose={() => setTaskDetailOpen(false)}
        task={selectedTask}
        onDelete={handleDeleteTask}
        onUpdatePersonnel={!isManager ? handleUpdatePersonnel : undefined} // Yöneticiler personel atayamaz
        personnel={personnel}
        getStatusColor={getStatusColor}
        getStatusIcon={getStatusIcon}
        getStatusLabel={getStatusLabel}
        readOnly={isManager} // Yönetici modu salt okunur
        companyId={companyId || ''} // Şirket ID'sini aktarıyoruz
        currentUserId={currentUser?.uid || ''} // Mevcut kullanıcı ID'sini aktarıyoruz
        // own-auth context üzerinden basic kullanıcı bilgisi
        currentUserName={currentUser?.displayName || (currentUser?.email ? currentUser.email.split('@')[0] : 'Admin Kullanıcı')}
        // completionPhotoUrl prop'u selectedTask üzerinden zaten geliyor olmalı, 
        // TaskDetailModal içinde task.completionPhotoUrl olarak erişilebilir.
      />

      {/* Görev Ekleme Modalı - hem yöneticiler hem de normal kullanıcılar görebilir */}
      <AddTaskModal
        open={addTaskModalOpen}
        onClose={() => setAddTaskModalOpen(false)}
        onAddTask={handleAddTask}
        onAddWeeklyTask={handleAddWeeklyTask}
        personnel={personnel}
        taskGroups={taskGroups}
        companyId={companyId || ''}
        branchId={branchId}
        isManager={isManager}
      />
      
      {/* Grup ekleme modalı - şimdi hem yöneticiler hem de normal kullanıcılar görebilir */}
      <TaskGroupsModal
        open={taskGroupsModalOpen}
        onClose={() => setTaskGroupsModalOpen(false)}
        companyId={companyId || ''}
        taskGroups={taskGroups}
        isManager={isManager}
        branchId={branchId}
        onGroupsChanged={reloadTaskGroups}
      />
      
      {/* Bu modallar her zaman gösterilsin */}
      {/* QR Kod Yazdırma Modalı */}
      <QrPrintModal
        open={qrPrintModalOpen}
        onClose={() => setQrPrintModalOpen(false)}
        task={selectedTaskForQr}
      />

      {/* Cihaz Bilgileri Modalı */}
      <DeviceInfoModal
        open={deviceModalOpen}
        onClose={handleCloseDeviceModal}
        deviceInfo={selectedDeviceInfo}
      />
      
      {/* Ekip Oluşturma Modalı */}
      <CreateTeamModal
        open={createTeamModalOpen}
        onClose={() => setCreateTeamModalOpen(false)}
        companyId={companyId}
        personnel={personnel}
      />
      
      {/* Ekip Görevi Ekleme Modalı */}
      <CreateTeamTaskModal
        open={createTeamTaskModalOpen}
        onClose={() => setCreateTeamTaskModalOpen(false)}
        companyId={companyId}
        teams={[]} // Ekip verileri TeamTasks içinde yönetiliyor
        personnel={personnel}
        taskGroups={taskGroups}
      />

      {/* Konum Modalı */}
      <TaskLocationModal
        open={taskLocationModalOpen}
        onClose={handleCloseTaskLocationModal}
        task={selectedTaskForLocation}
      />

      {/* Red Nedeni Modalı */}
      <Dialog
        open={rejectReasonModalOpen}
        onClose={() => setRejectReasonModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          bgcolor: 'error.light',
          color: 'white'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <CancelIcon sx={{ mr: 1 }} />
            <Typography variant="h6">{t('tasks.rejectReasonModal.title')}</Typography>
          </Box>
          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setRejectReasonModalOpen(false)}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            {selectedTask?.name || 'Görev'}
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {selectedTask?.description || ''}
          </Typography>
          
          <Paper variant="outlined" sx={{ p: 2, bgcolor: '#fff5f7' }}>
            <Typography variant="subtitle2" color="error" gutterBottom>
              {t('tasks.rejectReasonModal.reason')}
            </Typography>
            <Typography variant="body1">
              {selectedRejectReason}
            </Typography>
          </Paper>
          
          <Box sx={{ mt: 2 }}>
            <Typography variant="caption" color="text.secondary">
              {selectedTask?.rejectedAt ? `${t('tasks.rejectReasonModal.rejectionDate')} ${new Date(selectedTask.rejectedAt).toLocaleString('tr-TR')}` : ''}
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button 
            variant="contained" 
            onClick={() => setRejectReasonModalOpen(false)}
          >
            {t('tasks.rejectReasonModal.close')}
          </Button>
        </DialogActions>
      </Dialog>
    </ScrollableContent>
  );
};

export default Tasks; 
